import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";
import {useModal} from "../../../Context/ModalContext";
import EmptyLine from "../../EmptyLine";
import {useUser} from "../../../Context/UserContext";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import StationElevationPlot from "../UI/StationElevationPlot";
import ResultView from "../../V2/ResultView";
import {useAppContext} from "../../../Context/ProjectContextV2";
import StructureAssociateFootnote from "./StructureAssociateFootnote";

export function C4({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
            <StructureAssociateFootnote />
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.TCD001.error_id: {
            return (
                <>
                    <StructureDiffs row={row}/>
                </>
            )
        }
        case MessageCodes.Compare.TCD02.error_id: {
            return (
                <>
                    {
                        row.data.map(x => {
                            return (
                                <>
                                    <ResultText>
                                        There are following differences in the structure geometry of the inline structure at RS {<ComparisonCSName csName={x.cross_section} />}:
                                        <EmptyLine />
                                    </ResultText>
                                    {
                                        x?.weir_embank_diff?.length > 0 && (
                                            <ResultTable>
                                                <ResultHeader>
                                                    <ResultRow>
                                                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(70), textAlign: 'left'}}>
                                                            Inline Structre/Weir Embankment
                                                        </ResultHeaderCell>
                                                    </ResultRow>
                                                </ResultHeader>
                                                <ResultBody>
                                                    <ResultRow>
                                                        <ResultBodyCell>
                                                            {x?.weir_embank_diff.map(renderItem).join(', ')}
                                                        </ResultBodyCell>
                                                    </ResultRow>
                                                </ResultBody>
                                            </ResultTable>
                                        )
                                    }
                                    {
                                        x?.culvert_diff?.has_diff && (
                                            <ResultTable>
                                                <ResultHeader>
                                                    <ResultRow>
                                                        <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(70), textAlign: 'left'}}>
                                                            Inline Structre/Culverts
                                                        </ResultHeaderCell>
                                                    </ResultRow>
                                                </ResultHeader>
                                                <ResultBody>
                                                    {
                                                        x?.culvert_diff?.added?.length > 0 && x?.culvert_diff?.added?.map(c => (
                                                            <ResultRow>
                                                                <ResultBodyCell style={{width: 100}}>{c?.name}</ResultBodyCell>
                                                                <ResultBodyCell style={{width: 600}}>{`Added to ${c?.plan} plan`}</ResultBodyCell>
                                                            </ResultRow>
                                                        ))
                                                    }
                                                    {
                                                        x?.culvert_diff?.removed?.length > 0 && x?.culvert_diff?.removed?.map(c => (
                                                            <ResultRow>
                                                                <ResultBodyCell style={{width: 100}}>{c?.name}</ResultBodyCell>
                                                                <ResultBodyCell style={{width: 600}}>{`Removed from ${c?.plan} plan`}</ResultBodyCell>
                                                            </ResultRow>
                                                        ))
                                                    }
                                                    {
                                                        x?.culvert_diff?.diff?.length > 0 && x?.culvert_diff?.diff?.map(c => (
                                                            <ResultRow>
                                                                <ResultBodyCell style={{width: 100}}>{c?.culvert}</ResultBodyCell>
                                                                <ResultBodyCell style={{width: 600}}>{c?.diffs.map(renderItem).join(', ')}</ResultBodyCell>
                                                            </ResultRow>
                                                        ))
                                                    }
                                                </ResultBody>
                                            </ResultTable>
                                        )
                                    }
                                    <EmptyLine height={28}/>
                                </>
                            )
                        })
                    }
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

const filterItem = ({name, base, compare}) => {
    if(!base || !compare)
        return false

    return true
}

const renderItem = ({name, base, compare}) => {
    if((!base && !compare) || (base === '*' && compare === '*'))
        return name
    else if(base && !compare)
        return `${name} (${base}/None)`
    else if(!base && compare)
        return `${name} (None/${compare})`

    return `${name} (${base}/${compare})`
}

const StructureDiffs = ({row}) => {
    const {openModal, closeModal} = useModal();
    return (
        <>
            <ResultText>
                {
                    row.data.map(x => {
                        return (
                            <>
                                <ResultText>
                                    There are following differences in the structure geometry of the {x.type} at RS {<ComparisonCSName csName={x.cross_section} csNameVal={x.cross_section} />}:
                                    <EmptyLine />
                                </ResultText>
                                {
                                    x?.deck_dist_diff?.length > 0 && (
                                        <ResultTable>
                                            <ResultHeader>
                                                <ResultRow>
                                                    <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(70)}}>
                                                        Bridge/Culvert | Deck/Roadway
                                                    </ResultHeaderCell>
                                                </ResultRow>
                                            </ResultHeader>
                                            <ResultBody>
                                                <ResultRow>
                                                    <ResultBodyCell style={{width: HecRasHelper.getWidth(70), textAlign: 'left'}}>
                                                        {x?.deck_dist_diff?.map(renderItem).join(', ')}
                                                    </ResultBodyCell>
                                                </ResultRow>
                                            </ResultBody>
                                        </ResultTable>
                                    )
                                }
                                {
                                    x?.culvert_diff?.has_diff && (
                                        <ResultTable>
                                            <ResultHeader>
                                                <ResultRow>
                                                    <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(70), textAlign: 'left'}}>
                                                        Bridge/Culvert | Culvert
                                                    </ResultHeaderCell>
                                                </ResultRow>
                                            </ResultHeader>
                                            <ResultBody>
                                                {
                                                    x?.culvert_diff?.added?.length > 0 && x?.culvert_diff?.added?.map(c => (
                                                        <ResultRow>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10)}}>{c?.name}</ResultBodyCell>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(60)}}>{`Added to ${c?.plan} plan`}</ResultBodyCell>
                                                        </ResultRow>
                                                    ))
                                                }
                                                {
                                                    x?.culvert_diff?.removed?.length > 0 && x?.culvert_diff?.removed?.map(c => (
                                                        <ResultRow>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10)}}>{c?.name}</ResultBodyCell>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(60)}}>{`Removed from ${c?.plan} plan`}</ResultBodyCell>
                                                        </ResultRow>
                                                    ))
                                                }
                                                {
                                                    x?.culvert_diff?.diff?.length > 0 && x?.culvert_diff?.diff?.map(c => (
                                                        <ResultRow>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10)}}>{c?.name}</ResultBodyCell>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(60)}}>{c?.diffs.map(renderItem).join(', ')}</ResultBodyCell>
                                                        </ResultRow>
                                                    ))
                                                }
                                            </ResultBody>
                                        </ResultTable>
                                    )
                                }
                                {
                                    x?.pier_diff?.has_diff && (
                                        <ResultTable>
                                            <ResultHeader>
                                                <ResultRow>
                                                    <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(70), textAlign: 'left'}}>
                                                        Bridge/Culvert | Pier
                                                    </ResultHeaderCell>
                                                </ResultRow>
                                            </ResultHeader>
                                            <ResultBody>
                                                {
                                                    x?.pier_diff?.added?.length > 0 && x?.pier_diff?.added?.map(c => (
                                                        <ResultRow>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10)}}>{c?.name}</ResultBodyCell>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(60)}}>{`Added to ${c?.plan} plan`}</ResultBodyCell>
                                                        </ResultRow>
                                                    ))
                                                }
                                                {
                                                    x?.pier_diff?.removed?.length > 0 && x?.pier_diff?.removed?.map(c => (
                                                        <ResultRow>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10)}}>{c?.name}</ResultBodyCell>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(60)}}>{`Removed from ${c?.plan} plan`}</ResultBodyCell>
                                                        </ResultRow>
                                                    ))
                                                }
                                                {
                                                    x?.pier_diff?.diff?.length > 0 && x?.pier_diff?.diff?.map(c => (
                                                        <ResultRow>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10)}}>{c?.name}</ResultBodyCell>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(60)}}>{c?.diffs.map(renderItem).join(', ')}</ResultBodyCell>
                                                        </ResultRow>
                                                    ))
                                                }
                                            </ResultBody>
                                        </ResultTable>
                                    )
                                }
                                {
                                    x?.abutment_diff?.has_diff && (
                                        <ResultTable>
                                            <ResultHeader>
                                                <ResultRow>
                                                    <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(70), textAlign: 'left'}}>
                                                        Bridge/Culvert | Sloping Abutment
                                                    </ResultHeaderCell>
                                                </ResultRow>
                                            </ResultHeader>
                                            <ResultBody>
                                                {
                                                    x?.abutment_diff?.added?.length > 0 && x?.abutment_diff?.added?.map(c => (
                                                        <ResultRow>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(15)}}>{c?.name}</ResultBodyCell>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(55)}}>{`Added to ${c?.plan} plan`}</ResultBodyCell>
                                                        </ResultRow>
                                                    ))
                                                }
                                                {
                                                    x?.abutment_diff?.removed?.length > 0 && x?.abutment_diff?.removed?.map(c => (
                                                        <ResultRow>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(15)}}>{c?.name}</ResultBodyCell>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(55)}}>{`Removed from ${c?.plan} plan`}</ResultBodyCell>
                                                        </ResultRow>
                                                    ))
                                                }
                                                {
                                                    x?.abutment_diff?.diff?.length > 0 && x?.abutment_diff?.diff?.map(c => (
                                                        <ResultRow>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(15)}}>{c?.name}</ResultBodyCell>
                                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(55)}}>{c?.diffs.map(renderItem).join(', ')}</ResultBodyCell>
                                                        </ResultRow>
                                                    ))
                                                }
                                            </ResultBody>
                                        </ResultTable>
                                    )
                                }
                                <EmptyLine height={28}/>
                            </>
                        )
                    })
                }
            </ResultText>
        </>
    )
}